<template>
  <section class="attachments">
    <div :class="{ 'single-attachment': attachments.length === 1 }">
      <a
        :data-priority="attachment.priority"
        v-for="attachment in attachments"
        :key="attachment.url"
        :href="attachment.url"
        target="_blank"
        :class="isImage(attachment) ? 'glightbox' : ''"
      >
        <svg
          v-if="isPDF(attachment.mime)"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="var(--soslp-red)"
        >
          <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
        </svg>
        <svg
          v-else-if="isWord(attachment.mime)"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          fill="var(--soslp-blue-dark)"
        >
          <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          fill="var(--soslp-grey)"
        >
          <path d="M224 136V0H64C28.7 0 0 28.7 0 64V448C0 483.3 28.7 512 64 512H320C355.3 512 384 483.3 384 448V160H248C234.7 160 224 149.3 224 136zM384 121L263 0H248C234.7 0 224 10.7 224 24V136H384zM128 256C145.7 256 160 270.3 160 288C160 305.7 145.7 320 128 320H96V352H144C157.3 352 168 362.7 168 376C168 389.3 157.3 400 144 400H96V424C96 437.3 85.3 448 72 448C58.7 448 48 437.3 48 424V288C48 270.3 62.3 256 80 256H128zM288 272C304.7 272 320 286.3 320 304C320 321.7 304.7 336 288 336H256V368H288C301.3 368 312 378.7 312 392C312 405.3 301.3 416 288 416H256V440C256 453.3 245.3 464 232 464C218.7 464 208 453.3 208 440V304C208 286.3 222.3 272 240 272H288z" />
        </svg>
        <span>{{ attachment.name }}</span>
      </a>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  }
})

const attachments = computed(() => {
  return [...props.value].sort((a, b) => {
    if (a.priority === b.priority) {
      return a.id - b.id
    }
    return a.priority - b.priority
  })
})

const isPDF = (mime) => {
  return mime === 'application/pdf'
}

const isWord = (mime) => {
  return (
    mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    mime === 'application/msword'
  )
}

const isImage = (attachment) => {
  const imageMimeTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/webp',
    'image/avif',
    'image/svg+xml',
    'image/tiff'
  ]
  return imageMimeTypes.includes(attachment.mime)
}
</script>
